// ─────────────────────────────────────────────────────────────────────────────
// 🔑 A FORMATTED STAFF MESSAGE, AS THE SERVER RENDERED IT (the composer, 2026-10-31).
//
// body_html is written by the backend (utils/messageRichText) from an allow-list — p, br, strong, em, ul, ol, li and
// a (https/mailto, new tab, noopener) — after every tag the sender typed was removed. It is never built from client
// markup, which is why it can be set as HTML here. A message without body_html renders as it always did (the caller's
// plain-text branch); this returns null for it.
// ─────────────────────────────────────────────────────────────────────────────
import React from 'react';

export function hasRichBody(msg) {
  return !!(msg && typeof msg.body_html === 'string' && msg.body_html);
}

export default function RichMessageBody({ msg, dark = false }) {
  if (!hasRichBody(msg)) return null;
  return (
    <div
      data-testid="rich-message"
      className={`doorly-rich-message${dark ? ' doorly-rich-message--dark' : ''}`}
      dangerouslySetInnerHTML={{ __html: msg.body_html }}
    />
  );
}
